function phoneMask(input) {
  // Фоллбек страны по языку страницы
  var fallbackCountry = (function () {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('ru') === 0) return 'ru';
    if (lang.indexOf('tr') === 0) return 'tr';
    if (lang.indexOf('en') === 0) return 'gb';
    return 'us';
  })();

  var iti = window.intlTelInput(input, {
    autoPlaceholder: 'aggressive',
    formatOnDisplay: false,
    nationalMode: false,
    preferredCountries: ['gb', 'tr'],
    separateDialCode: true,
    initialCountry: 'auto',
    geoIpLookup: function (callback) {
      fetch('https://ipapi.co/json')
        .then(function (res) {
          if (!res.ok) {
            throw new Error('ipapi error');
          }
          return res.json();
        })
        .then(function (data) {
          if (data && data.country_code) {
            callback(data.country_code);
          } else {
            callback(fallbackCountry);
          }
        })
        .catch(function () {
          callback(fallbackCountry);
        });
    }
  });

  // Снимаем любое ограничение длины, которое может навесить intl-tel-input
  input.removeAttribute('maxlength');

  var observer = new MutationObserver(function () {
    var dropdown = document.querySelector('.iti__country-list');
    if (dropdown && dropdown.offsetParent !== null) {
      document.body.classList.add('body-iti-open');
    } else {
      document.body.classList.remove('body-iti-open');
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // При смене страны очищаем поле и снова убираем maxlength
  input.addEventListener('countrychange', function (e) {
    var target = e.target;
    target.value = '';
    target.removeAttribute('maxlength');
  });

  input.addEventListener('blur', function () {
    if (iti.isValidNumber()) {
      input.parentNode.parentNode.classList.remove('is-invalid');
      input.parentNode.parentNode.classList.add('is-valid');
    } else {
      input.parentNode.parentNode.classList.add('is-invalid');
      input.parentNode.parentNode.classList.remove('is-valid');
    }
  });

  input.addEventListener('keyup', function () {
    if (iti.isValidNumber()) {
      input.parentNode.parentNode.classList.remove('is-invalid');
      input.parentNode.parentNode.classList.add('is-valid');
    }
  });
}

// Инициализация для обоих классов: js-input-tel и js-input-tel-popup
var inputTelArr = document.querySelectorAll('.js-input-tel, .js-input-tel-popup');
if (inputTelArr.length > 0) {
  inputTelArr.forEach(function (inp) {
    phoneMask(inp);

    inp.addEventListener('keydown', function (e) {
      if (e.key === '0' && inp.value.length === 0) {
        e.preventDefault();
        inp.value = '';
      }
    });

    inp.addEventListener('keyup', function () {
      if (inp.value.slice(0, 1) === '0') {
        inp.value = inp.value.slice(1);
      }
    });

    inp.addEventListener('blur', function () {
      if (inp.value.slice(0, 1) === '0') {
        inp.value = inp.value.slice(1);
      }
    });
  });
}

Fancybox.bind("[data-fancybox]", {
    dragToClose: false,
    autoFocus: false,
    placeFocusBack: false,
});